import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-navy-border text-center px-4" data-id="element-98" data-mp="32wmqdx7xtgw2">
      <div className="max-w-4xl mx-auto" data-id="element-99" data-mp="3gg1025qei1yp"><p className="text-gold-dark text-sm" data-id="element-100" data-mp="3gh3qydnq44em">© {new Date().getFullYear()} Research Methods Teacher Ready™ — All rights reserved.</p></div>
    </footer>;
}